<template>
  <v-container fluid grid-list-md align-center class="bg">
    <ComponentAdminLogin />
  </v-container>
</template>

<script>
import ComponentAdminLogin from "@/components/admin/ComponentAdminLogin";
export default {
  components: {
    ComponentAdminLogin,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$cookies.get("admin_name") !== null) {
        next({ path: "/report_nursery" });
      }
    });
  },
  methods: {},
};
</script>

<style scoped>
.bg {
  background-image: url("../../../src/assets/images/bg-home.jpg");
  background-size: cover;
  /* background-position: top; */
  /* background-repeat: repeat-x; */
}
</style>
